<template>
  <component :is="icon" v-bind="$attrs" width="16" height="16" />
</template>

<script setup lang="ts">
import { defineAsyncComponent, markRaw, onMounted, ref, watch } from "vue";

interface IProps {
  name: JBIconName;
}

const props = withDefaults(defineProps<IProps>(), { name: 'help' });
const icon = ref();

onMounted(() => {
  setIcon(props.name);
});

watch(() => props.name, (name: string) => {
  setIcon(name);
});

function setIcon(name: string) {
  icon.value = markRaw(defineAsyncComponent(() => import(`../assets/icons/${name}.svg`)));
}
</script>
